import {
  getS3UploadOptions,
  S3UploadOptions,
} from '../../store/Auth/auth.reducer';
import { AppState } from '../../store/reducers';
import * as React from 'react';
import * as DropzoneS3Uploader from 'react-dropzone-s3-uploader';
import { connect } from 'react-redux';
import green from 'material-ui/colors/green';
import red from 'material-ui/colors/red';
import UploadDisplay from './components/UploadDisplay';
import { last, match } from 'ramda';

const styles = {
  container: {
    height: '100%',
  },
  select: {
    border: 'dashed 1px rgba(255, 255, 255, 0.12)',
    minHeight: 140,
  },
  selectFileButton: {
    color: '#ffff8c',
  },
  paper: {
    position: 'relative',
  },
  closeIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 10000,
    color: 'black',
  },
  mediaWrapper: {
    width: '100%',
  },
  successButton: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  errorButton: {
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  progress: {
    color: green[500],
    position: 'absolute',
    top: -2,
    left: -2,
  },
};

export interface S3Result {
  s3Path: string;
  filePath: string;
}

export interface UploaderFile {
  filename: string;
  fileUrl: string;
}

interface StateProps {
  uploadOptions: S3UploadOptions;
}

interface OwnProps {
  onFileUploaded: (result: S3Result) => void;
}

type Props = StateProps & OwnProps;

class S3MediaDropzone extends React.PureComponent<Props> {
  private handleFinishedUpload = (info: { signedUrl: string }) => {
    const { onFileUploaded } = this.props;
    const { signedUrl } = info;
    if (signedUrl) {
      const filePath = last(match(/.com\/(.*)\?/i, signedUrl)) as string;
      const result = {
        s3Path: signedUrl,
        filePath: filePath,
      };
      onFileUploaded(result);
    }
  };

  public render() {
    const { uploadOptions } = this.props;

    return (
      <DropzoneS3Uploader
        style={styles.container}
        onFinish={this.handleFinishedUpload}
        maxSize={1024 * 1024 * 10}
        s3Url={uploadOptions.s3Url}
        upload={uploadOptions}
      >
        <UploadDisplay />
      </DropzoneS3Uploader>
    );
  }
}

function mapStateToProps(state: AppState, ownProps: OwnProps) {
  return {
    uploadOptions: getS3UploadOptions(state),
  };
}

export default connect(mapStateToProps)(S3MediaDropzone);



// WEBPACK FOOTER //
// ./src/modules/S3MediaDropzone/index.tsx